import React from "react";
import "./App.css";
import About from "./pages/About";
import Footer from "./pages/Footer";
import Experience from "./pages/Experience";
import Home from "./pages/Home";
import Project from "./pages/Project";
import Skills from "./pages/Skills";
export default function App() {
  return (
    <div>
      <Home />
      <About />
      <Skills />
      <Project />
      <Experience />
      <Footer />
    </div>
  );
}
